import { ChangeDetectorRef, Component, Input, OnInit, QueryList, ViewChildren } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, FormGroupDirective, Validators } from '@angular/forms';
import { UploadDokumentArt } from '../../../shared/enum';
import { IAntrag } from '../../models/antrag';
import { IFile } from '../../models/file';
import { VermittlerService } from '../../service/vermittler.service';
import { FileUploadComponent } from '../file-upload/file-upload.component';

@Component({
  selector: 'app-fertigstellen',
  templateUrl: './fertigstellen.component.html',
  styleUrls: ['./fertigstellen.component.scss']
})
export class FertigstellenComponent implements OnInit {

  @Input()
  parentFormGroupDirective: FormGroupDirective;

  @Input()
  formGroup: UntypedFormGroup;

  @Input()
  selectedFiles: IFile[];

  offertBaseId: number;
  dokumentArten = UploadDokumentArt;
  eingereicht: boolean;
  einreichdatum: Date;

  @ViewChildren(FileUploadComponent) fileUploadComponents: QueryList<FileUploadComponent>;

  constructor(private ref: ChangeDetectorRef, public vermittlerService: VermittlerService) { }

  static createFormGroup(fb: UntypedFormBuilder) {
    return fb.group({
      antragUebernehmen: new UntypedFormControl('1', Validators.required)
    });
  }

  ngOnInit(): void {
    this.onValueChanged();
  }

  get antragUebernehmen() { return this.formGroup.get('antragUebernehmen'); }

  get showUploadAntrag() {
    return this.antragUebernehmen.value === '2' ? true : false;
  }

  onValueChanged(): void {
    this.antragUebernehmen.valueChanges.subscribe(() => {
      this.ref.detectChanges();
    });
  }

  setAntrag(antrag: IAntrag) {
    this.antragUebernehmen.setValue(antrag.AntragUebernehmen != null ? antrag.AntragUebernehmen === true ? '1' : '2' : null);
    this.einreichdatum = antrag.Einreichdatum;
    this.eingereicht = antrag.Eingereicht;
    if (this.eingereicht) {
      this.antragUebernehmen.disable();
    }
    this.offertBaseId = antrag.OffertBaseId;
  }

  getAntrag(): IAntrag {
    return {
      AntragUebernehmen: this.antragUebernehmen.value ? this.antragUebernehmen.value === '1' ? true : false : null,
    } as IAntrag;
  }
}
